const ViewSettlement = () => {
  return <>
    view
  </>
}

export default ViewSettlement;